import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { WindowService } from '@shared/window';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-complaints',
    templateUrl: './complaints.component.html',
    styleUrls: ['./complaints.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class ComplaintsComponent implements OnInit {
    private windowService = inject(WindowService);

    ngOnInit() {
        this.windowService.scrollTop();
    }
}
